export default "/images/vendor/intl-tel-input/build/flags@2x.webp?bea0200ba7ea874b359fd5423614fef5";